import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData, updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant"
import { FILTER__FORM_FIELDS_GLOBAL, getDropdowns, SEARCH_BY } from './constants';
// import { getAllActivePaymentMode } from "../../../views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/utils";
import FilterForm from "./FilterForm";
import ListComponent from "./ListComponent";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getBuAgainstBuTypes } from "../refundMasters/refundsApprovalConfig/services";
import { DIGITAL_BUSINESS_IDS } from "views/pages/manage/common/hook/useCashierOfficeDropdown";
import { regex } from "views/pages/manage/common/constant/regex/index";
import { getRefundReason } from "../refundApproval/utils";


const RefundTracker = ({ userPermissions }) => {
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, "U");

    const history = useHistory();
    const ref = useRef();

    const [isloading, setIsLoading] = useState([]);
    const [dropdowns, setDropdowns] = useState([]);
    const [refunds, setRefunds] = useState([]);
    const [selected, setSelected] = useState("psid");
    const [searchInput, setSearchInput] = useState("");
    const [filterForm, setFilterForm] = useState({
        ...FILTER__FORM_FIELDS_GLOBAL,
    });
    const [filterCount, setFilterCount] = useState(
        getFilterCount({ ...filterForm }, ["searchByValue", "searchBy"])
    );
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const [buLoading, setBuLoading] = useState(false);
    const [refundReasons, setAllRefundReasons] = useState([]);

    const init = async () => {
        try {
            setIsLoading(true);
            const res = await getDropdowns();
            const allRefundReasons = await getRefundReason('COMPLETION_REFUND');
            // const paymodeDropdown = await getAllActivePaymentMode();
            setDropdowns(res);
            setAllRefundReasons(allRefundReasons);
            getAllRefunds({}, 0, currPageSize, res);
        } catch (err) {
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, []);

    const getAllRefunds = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, dropdowns) => {
        try {
            setIsLoading(true);
            const resp = await fetchAllPostPromisedData(
                `${endpoint?.refundTracker.search}?offset=${pageNumber}&limit=${pageSize}`,
                { ...reqObj },
                "post"
            );

            if (resp?.code === 200) {
                const updatedData = resp?.data?.paginatedData ? resp?.data?.paginatedData?.map(({ businessArea,  cashierOffice, ...rest }, index) => {
                    return {
                        ...rest,
                        id: index,
                        businessArea: dropdowns?.businessArea?.find(bu => bu?.value == businessArea),
                       cashierOffice: dropdowns?.businessArea?.find(co => co?.label === cashierOffice)
                    }
                }) : [];
                setCurrentPageSize(pageSize);
                setRefunds(updatedData);
                setPaginationInfo({
                    currPageNo: resp?.data?.currentPage,
                    currPageSize: pageSize,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords ?? 0,
                });
            }
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    };

    const applyFilterHandler = (pageNumber = 0, reqObj = {}) => {
        const { cashierOffice, refundTypes } = reqObj;

        let itemVal = updateRequest(reqObj);

        itemVal = {
            ...itemVal,
            cashierOffice: cashierOffice?.map(c => c.label) || []
        };

        if (Array.isArray(refundTypes)) {
            itemVal.refundTypes = refundTypes.flatMap(rt =>
                Array.isArray(rt?.value) ? rt.value : rt?.value
            );
        }

        getAllRefunds(itemVal, 0, currPageSize, dropdowns);
    };


    const nextButtonHandler = (newPage, currPageSize) => {
        const itemVal = updateRequest(filterForm);
        getAllRefunds(itemVal, newPage, currPageSize, dropdowns);
    };

    const searchInputHandler = (value = searchInput) => {
        const updatedFilters = {
            ...filterForm,
            searchBy: value ? selected : "",
            searchByValue: value,
        };
        setFilterForm(updatedFilters);

        const req = value ? { [selected]: value } : {};
        getAllRefunds(req, 0, currPageSize, dropdowns);
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            searchInputHandler();
        }
    };

    const handleOnUserInput = (value) => {
        setSearchInput(value);
        if (value === "" && value !== filterForm.searchByValue)
            searchInputHandler(value);
    };

    const crossHandler = () => {
        getAllRefunds({ ...filterForm, searchByValue: '' }, 0, currPageSize, dropdowns);
        setFilterForm((prev) => ({ ...prev, searchByValue: '' }));
        setSearchInput("");
    }

    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    };

    const buTypeChangeHandler = async (selectedBranchType) => {
        try {
            filterFormHandler("branchType", [selectedBranchType]);

            let buAgainstBranchTypes = [];

            const branchTypeValue = typeof selectedBranchType?.value === "string"
                ? selectedBranchType.value.toLowerCase()
                : null;

            if (branchTypeValue === "advance") {
                buAgainstBranchTypes = dropdowns?.advanceBusinessAreas ?? [];
            } else if (selectedBranchType) {
                buAgainstBranchTypes = await getBuAgainstBuTypes(selectedBranchType, setBuLoading);
                buAgainstBranchTypes = buAgainstBranchTypes?.filter(bu => !DIGITAL_BUSINESS_IDS?.includes(bu?.label))
            }

            filterFormHandler("businessArea", []);
            setDropdowns(prev => ({
                ...prev,
                businessAreas: buAgainstBranchTypes
            }));

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <Card className="mx-2">
                <div className="d-flex justify-content-between my-3 mx-2">
                    <div className="d-flex justify-content-between">
                        <BackArrow
                            className="color-black mr-2 cursor"
                            onClick={() => history.goBack()}
                        />
                        <h4 className="color-black">Refund tracker</h4>
                    </div>
                    <div className="d-flex justify-content-between">
                        <AInput
                            placeholder="Search"
                            className=""
                            value={searchInput}
                            handler={handleOnUserInput}
                            onKeyDown={onKeyDownHandler}
                            searchIconClickHandler={() => {
                                searchInputHandler();
                            }}
                            crossIcon={false}
                            searchIcon={true}
                            style={{ width: "300px" }}
                            crossHandler={crossHandler}
                            customSearchIconStyle={{ left: "5px" }}
                            rightCustomIconStyles={{
                                fontSize: "12px",
                                position: "absolute",
                                bottom: "7px",
                                right: "43%",
                                margin: "auto",
                            }}
                            rightCustomIcon={
                                <select
                                    value={selected}
                                    onChange={(e) => setSelected(e.target.value)}
                                    style={{
                                        position: "absolute",
                                        bottom: "0",
                                        margin: "auto 0",
                                        background: "#FFF6E3",
                                        color: "#A17217",
                                        border: "none",
                                    }}
                                >
                                    {SEARCH_BY.map(({ key, value }) => (
                                        <option value={key}>{value}</option>
                                    ))}
                                </select>
                            }
                            regex={regex?.numeric}
                        />
                        <APopover
                            buttonComponent={(onClick, styles) => (
                                <AButton
                                    className="tiny-semi-bold color-dark"
                                    onClick={onClick}
                                    updatedStyle={{
                                        minWidth: "61px",
                                        ...(filterCount > 0
                                            ? {
                                                border: "1px solid #00B0F5",
                                                color: "#00B0F5",
                                            }
                                            : styles),
                                    }}
                                >
                                    Filters {filterCount > 0 && <>( {filterCount} )</>}
                                </AButton>
                            )}
                            menuComponent={(closePopup) => (
                                <FilterForm
                                    closePopup={closePopup}
                                    dropdownData={dropdowns}
                                    filterForm={filterForm}
                                    filterCount={filterCount}
                                    setFilterCount={setFilterCount}
                                    setFilterForm={setFilterForm}
                                    applyFilterHandler={applyFilterHandler}
                                    filterFormHandler={filterFormHandler}
                                    buTypeChangeHandler={buTypeChangeHandler}
                                    buLoading={buLoading}
                                />
                            )}
                        />
                        {/* <AButton
                            variant="primary_filled"
                            onClick={() => ref.current.addNewRow()}
                            size="xs"
                        >
                            + Add configuration
                        </AButton> */}
                    </div>
                </div>

                <ListComponent
                    rows={refunds}
                    ref={ref}
                    isloading={isloading}
                    setIsLoading={setIsLoading}
                    nextButtonHandler={nextButtonHandler}
                    dropdowns={dropdowns}
                    isUpdatePermission={isUpdatePermission}
                    refundReasons={refundReasons}
                    paginationInfo={paginationInfo}
                />
            </Card>
        </>
    )
}

export default RefundTracker;